import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { from, Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FirebaseTokenService {
    private readonly destroyRef = inject(DestroyRef);

    private readonly authInitialized = signal(false);

    constructor() {
        from(
            FirebaseAuthentication.addListener('authStateChange', () => {
                if (!this.authInitialized()) {
                    this.authInitialized.set(true);
                }
            })
        )
            .pipe(
                catchError(() => {
                    this.authInitialized.set(true);
                    return of(null);
                })
            )
            .subscribe();

        this.destroyRef.onDestroy(() => {
        });
    }

    getIdToken$(): Observable<string | null> {
        return toObservable(this.authInitialized).pipe(
            filter(Boolean),
            take(1),
            switchMap(() => from(FirebaseAuthentication.getIdToken())),
            map(res => res?.token ?? null),
            catchError(() => of(null))
        );
    }
}